module.exports = __webpack_public_path__ + "static/1.2Start_infinity-fc6c1d915640a50c364e2b4653ceeb5e.gif";